
<template>
  <div class="promotionBanner-component">
      <img class="bgImage" v-lazy="url" alt="">
      <div class="box" v-if="type">
          <h1 :style="{color: title_color, fontSize: title_size, fontFamily: titleFamily, }">{{title | font10}}</h1>
          <h4 :style="{color: sub_title_color, fontSize: sub_title_size, fontFamily: subTitleFamily, }">{{sub_title | font15}}</h4>
      </div>
  </div>
</template>

<script >
import _ from 'lodash'
export default {
    name: 'promotionBanner',
    props: {
        dataSource: {
            type: Object,
            required: true
        },
        type: {
            type: Number,
            default: 1 // 0：常规，1：自定义
        }
    },
    watch: {
        dataSource: {
            handler: function (newValue) {
                const obj = _.cloneDeep(newValue)
                obj.sub_title_size = obj.sub_title_size ? (Number(obj.sub_title_size) / 75).toFixed(2) + 'rem' : ''
                obj.title_size = obj.title_size ? (Number(obj.title_size) / 75).toFixed(2) + 'rem' : ''
                Object.assign(this, obj)
            },
            deep: true
        }
    },
    computed: {
        titleFamily () {
            return this.title_family ? 'fc' + this.title_family : ''
        },
        subTitleFamily () {
            return this.sub_title_family ? 'fc' + this.sub_title_family : ''
        },
    },
    filters: {
        font10 (value) {
            return value ? value.substr(0, 10) : ''
        },
        font15 (value) {
            return value ? value.substr(0, 15) : ''
        }
    },
    data () {
        return {
            sub_title: '',
            sub_title_color: '',
            sub_title_family: '',
            sub_title_size: '',
            title: '',
            title_color: '',
            title_family: '',
            title_size: '',
            url: ''
        }
    },
    created () {
        // this.loadFont()
    },
    activated () {

    },
    mounted () {
    },
    methods: {
        loadFont () {
            const fonts = {
                bold: '../../../assets/font/PingFang_Bold.ttf', // 萍方粗体
                medium: '../../../assets/font/PingFang_Medium.ttf', // 萍方中等
                sun: '../../../assets/font/canger.ttf', // 仓耳渔阳体W05
            }
            if (this.sub_title_family || this.title_family) {
                let text = ''
                let style = document.createElement('style')
                style.type = 'text/css'
                if (this.sub_title_family) {
                    text += `@font-face {
                                            font-family:${'fc' + this.sub_title_family};
                                            src:url('../../../assets/font/${fonts[this.sub_title_family]}.ttf')
                                        };`
                }
                if (this.title_family) {
                    text += `@font-face {
                                font-family:${'fc' + this.title_family};
                                src:url('../../../assets/font/${fonts[this.title_family]}.ttf')
                            };`
                }
                style.innerText = text
                document.getElementsByTagName('head')[0].appendChild(style)
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "../../../assets/stylus/variables";

.promotionBanner-component
    position relative
    width 100%
    .bgImage
        display block
        width 100%
    .box
        position absolute
        top 0
        left 0
        z-index 2
        width 100%
        text-align center
        h1
            padding-top 95px
            font-size 54px
            line-height 1
        h4
            padding-top 30px
            font-size $fontLarger
            line-height 1
</style>
